class Filter {
	constructor(select) {
		this.select = select;
		this.select.addEventListener("click", () => {
			this.toggle();
		});
	}

	toggle() {
		this.select.classList.toggle("sui-active");
	}

	hide() {
		this.select.classList.remove("sui-active");
	}
}

export const GenerateFilter = (block) => {
	const filterList = [];
	const selectList = block.querySelectorAll(".sui-input-select");

	selectList.forEach((item) => {
		filterList.push(new Filter(item));
	});

	document.addEventListener("click", (event) => {
		const target = event.target;
		let isFilter = false;

		filterList.forEach((filter) => {
			if (!filter.select.contains(target)) {
				filter.hide();
			}
		});
	});
};
